if (!customElements.get('currency-selector')) {
  customElements.define(
    'currency-selector',
    class CurrencySelector extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.currency-selector_toggle');
        this.list = this.querySelector('.currency-selector_list');
        if (!this.toggle || !this.list) return;

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };

        this.toggle.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.isOpen) return;
          event.stopPropagation();
          this.close();
          this.toggle.focus();
        });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.list.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        const current = this.list.querySelector('[aria-current="true"]');
        if (current) this.list.scrollTop = current.parentElement.offsetTop - this.list.clientHeight / 2;
        document.addEventListener('click', this.onDocumentClick);
      }

      close() {
        this.list.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
      }
    }
  );
}
